<!-- 章节列表弹窗 -->
<template>
  <div>
    <!-- 小说信息 -->
    <div class="novel-info">
      <h3>{{ novelName }} (共{{ total }}条)</h3>
    </div>

    <!-- 搜索区域 -->
    <el-form
      :inline="true"
      :model="query"
      class="filter-form"
    >
      <el-form-item label="章节序号：">
        <el-input
          v-model.number="query.chapter_index"
          type="number"
          min="1"
          placeholder="请输入章节序号"
          clearable
          style="width: 180px"
          @blur="handleChapterIndex"
        />
      </el-form-item>
      <el-form-item label="章节名称：">
        <el-input
          v-model="query.chapter_name"
          placeholder="请输入章节名称"
          clearable
          style="width: 220px"
        />
      </el-form-item>
      <!-- <el-form-item label="章节状态：">
        <el-select
          v-model="query.status"
          placeholder="请选择"
          clearable
          style="width: 160px"
        >
          <el-option label="正常" :value="1" />
          <el-option label="下架" :value="2" />
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <!-- 章节列表（卡片样式） -->
    <div v-loading="loading" class="chapter-list">
      <div
        v-for="item in tableData"
        :key="item.chapter_index"
        class="chapter-card"
        @click="showChapterDetail(item)"
      >
        <div class="chapter-title">
          第 {{ item.chapter_index + 1 }} 章
        </div>
        <div class="chapter-name">
          章节名称：
          <span class="chapter-name-text">
            {{ item.chapter_name }}
          </span>
        </div>
        <div v-if="item.status_text" class="chapter-status">
          {{ item.status_text }}
        </div>
      </div>
      <div v-if="!loading && (!tableData || tableData.length === 0)" class="empty-tip">
        暂无数据
      </div>
    </div>

    <!-- 分页 -->
    <pagination-right
      :current-page="query.page"
      :page-sizes="[50, 100, 200]"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <!-- 章节内容弹窗 -->
    <el-dialog
      :visible.sync="chapterDetailVisible"
      :title="chapterDetailTitle"
      width="60%"
      :append-to-body="true"
    >
      <div v-if="chapterDetailText" class="chapter-text-wrapper">
        <pre class="chapter-text">{{ chapterDetailText }}</pre>
      </div>
      <div v-else class="chapter-text-empty">
        暂无章节内容
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { chapterList } from '@/api/miniProgramPhotoGallery.js'
import PaginationRight from '@/components/PaginationRight/index.vue'

export default {
  components: { PaginationRight },
  data() {
    return {
      tableData: [],
      novelNo: '',
      novelName: '',
      loading: false,
      query: {
        page: 1,
        pageSize: 50,
        chapter_name: '',
        chapter_index: null,
        status: null
      },
      total: 0,
      chapterDetailVisible: false,
      chapterDetailTitle: '',
      chapterDetailText: ''
    }
  },
  methods: {
    // 打开弹窗并加载数据
    open(novelNo, novelName) {
      this.novelNo = novelNo
      this.novelName = novelName || ''
      this.resetQuery()
      this.list()
    },
    // 获取章节列表
    list() {
      if (!this.novelNo) {
        return
      }
      this.loading = true
      const params = {
        novel_no: this.novelNo,
        page: this.query.page,
        pageSize: this.query.pageSize
      }
      if (this.query.chapter_name) {
        params.chapter_name = this.query.chapter_name
      }
      if (this.query.chapter_index) {
        params.chapter_index = this.query.chapter_index
      }
      if (this.query.status !== null && this.query.status !== '') {
        params.status = this.query.status
      }

      chapterList(params).then((res) => {
        this.tableData = res.data.list || []
        this.total = res.data.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.query.page = 1
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    // 搜索
    handleSearch() {
      this.query.page = 1
      this.list()
    },
    // 重置
    handleReset() {
      this.resetQuery()
      this.list()
    },
    // 重置查询条件
    resetQuery() {
      this.query = {
        page: 1,
        pageSize: 50,
        chapter_name: '',
        chapter_index: null,
        status: null
      }
    },
    // 展示章节内容
    showChapterDetail(item) {
      this.chapterDetailTitle = `第 ${item.chapter_index + 1} 章：${item.chapter_name || ''}`
      // 后端字段名假设为 chapter_text，如有不同请在此处调整
      this.chapterDetailText = item.chapter_text || ''
      this.chapterDetailVisible = true
    },
    handleChapterIndex() {
      if (!this.query.chapter_index || this.query.chapter_index < 1) {
        this.query.chapter_index = 1
      }
    }
  }
}
</script>

<style scoped>
.novel-info {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.novel-info h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.filter-form {
  margin-bottom: 16px;
}

.chapter-list {
  max-height: 500px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  overflow-y: auto;
}

.chapter-card {
  box-sizing: border-box;
  width: 19%;
  min-width: 220px;
  margin: 8px 0.5%;
  padding: 16px 18px;
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  border: 1px solid #ebeef5;
}

.chapter-title {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 6px;
}

.chapter-name {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chapter-name-text {
  color: #409eff;
}

.chapter-status {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}

.empty-tip {
  width: 100%;
  text-align: center;
  color: #909399;
  padding: 40px 0;
}

.chapter-text-wrapper {
  max-height: 600px;
  overflow-y: auto;
  padding-right: 8px;
}

.chapter-text {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.8;
  font-size: 14px;
  color: #303133;
}

.chapter-text-empty {
  text-align: center;
  color: #909399;
  padding: 40px 0;
}
</style>

